/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./Placeholder.vue.js?vue&type=template&id=52c1cde2!=!../../../node_modules/@rsbuild/plugin-vue2/node_modules/vue-loader/lib/index.js??vue-loader-options!./Placeholder.vue?vue&type=template&id=52c1cde2"
import script from "./Placeholder.vue.ts?vue&type=script&lang=ts&setup=true!=!../../../node_modules/@rsbuild/plugin-vue2/node_modules/vue-loader/lib/index.js??vue-loader-options!./Placeholder.vue?vue&type=script&lang=ts&setup=true"
export * from "./Placeholder.vue.ts?vue&type=script&lang=ts&setup=true!=!../../../node_modules/@rsbuild/plugin-vue2/node_modules/vue-loader/lib/index.js??vue-loader-options!./Placeholder.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/@rsbuild/plugin-vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports